import Vue from 'vue'
import App from '../components/products/ProductsSmall.vue'

Vue.prototype.$product_data = product_data;

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    render: h => h(App)
  }).$mount('#products-small')
})